import React, { Fragment } from 'react';

import ChannelShare from './channelShare';
import { ArrowLeft } from '../../../../assets/images/index';

import { StyledBackBtn, StyledBackBtnIcon } from './style';

import { dataDailyShareModel } from '../../../utils/models';

const ChannelShareDetail = ({ data }) => (
  <Fragment>
    <StyledBackBtn to="/audiencias">
      <StyledBackBtnIcon
        className="arrow_icon_share"
        color="dark"
        svg={ArrowLeft}
        size="sm"
      />
      VOLVER
    </StyledBackBtn>
    <ChannelShare data={data} reduced={false} />
  </Fragment>
);

ChannelShareDetail.propTypes = {
  data: dataDailyShareModel
};

export default ChannelShareDetail;
